import type React from 'react';
import Table, { Pagination, type PaginationProps, type TableProps } from '~/components2/Table';

interface Props<TData, TValue> extends TableProps<TData, TValue> {
  children?: React.ReactNode;
  pagination?: Omit<PaginationProps, 'table'>;
}

export default function <TData = any[], TValue = any>({ children, pagination, ...props }: Props<TData, TValue>) {
  return (
    <Table
      {...props}
      topSection={
        <div className="flex w-full items-center justify-between bg-white py-2">
          <Pagination table={props.table} {...pagination} />
          <div className="mr-6 flex items-center space-x-2">{children}</div>
        </div>
      }
    />
  );
}
